var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalbalance2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 117,
    viewBox: "0 0 240 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_1191)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00244141,
    width: 240,
    height: 117,
    rx: 8,
    fill: "#14170E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.65635 119.752L1.20635 100.152C-0.120731 99.642 -1.37024 99.0295 -2.54215 98.3149C-3.71407 97.6004 -4.86353 96.8347 -5.99052 96.0181L-24.2124 103.674L-41.0562 74.5806L-25.2843 62.6368C-25.3864 61.9222 -25.4374 61.2342 -25.4374 60.5727V56.4383C-25.4374 55.7727 -25.3864 55.0826 -25.2843 54.3681L-41.0562 42.4243L-24.2124 13.3306L-5.99052 20.9868C-4.86761 20.1701 -3.69365 19.4045 -2.46865 18.6899C-1.24365 17.9754 -0.0186501 17.3629 1.20635 16.8524L3.65635 -2.74756H37.3438L39.7938 16.8524C41.1209 17.3629 42.3725 17.9754 43.5485 18.6899C44.7245 19.4045 45.8719 20.1701 46.9907 20.9868L65.2126 13.3306L82.0563 42.4243L66.2845 54.3681C66.3866 55.0826 66.4376 55.7727 66.4376 56.4383V60.5666C66.4376 61.2321 66.3355 61.9222 66.1313 62.6368L81.9032 74.5806L65.0595 103.674L46.9907 96.0181C45.8678 96.8347 44.6938 97.6004 43.4688 98.3149C42.2439 99.0295 41.0188 99.642 39.7938 100.152L37.3438 119.752H3.65635ZM20.8064 79.9399C26.7272 79.9399 31.7803 77.8472 35.9657 73.6618C40.1511 69.4764 42.2439 64.4233 42.2439 58.5024C42.2439 52.5816 40.1511 47.5285 35.9657 43.3431C31.7803 39.1576 26.7272 37.0649 20.8064 37.0649C14.7834 37.0649 9.70377 39.1576 5.56735 43.3431C1.43093 47.5285 -0.635235 52.5816 -0.631149 58.5024C-0.631149 64.4233 1.43705 69.4764 5.57347 73.6618C9.70989 77.8472 14.7875 79.9399 20.8064 79.9399Z",
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.935 34.0024H31.687L30.411 30.3194H23.828L22.552 34.0024H19.304L25.365 16.6604H28.903L34.935 34.0024ZM29.454 27.4194L27.134 20.5754L24.785 27.4194H29.454ZM40.237 34.0024H37.192V16.6604H40.237V34.0024Z",
    fill: "#10C237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.787 85.4734H25.858C25.7807 85.4734 25.7227 85.4831 25.684 85.5024C24.988 85.9084 24.524 86.4111 24.292 87.0104L21.392 86.1404C21.566 85.6764 21.769 85.2898 22.001 84.9804C23.2383 83.3758 24.4853 82.5734 25.742 82.5734H28.816C29.57 82.5734 30.2467 82.7958 30.846 83.2404C31.0587 83.3758 31.339 83.6271 31.687 83.9944C32.0543 84.3424 32.3057 84.6131 32.441 84.8064C32.789 85.3284 32.963 85.9181 32.963 86.5754V88.4314C32.963 89.7848 32.2477 90.8288 30.817 91.5634L25.104 94.5214C24.7947 94.6954 24.64 94.8984 24.64 95.1304V97.1024H32.76V100.002H21.595V95.0144C21.595 93.6998 22.32 92.6654 23.77 91.9114L29.541 88.9244C29.7923 88.8084 29.918 88.6151 29.918 88.3444V86.5754L29.889 86.4304C29.7537 86.1984 29.57 85.9858 29.338 85.7924C29.106 85.5798 28.9223 85.4734 28.787 85.4734Z",
    fill: "#10C237"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2007_1191)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.539 81.501L184.27 34.0024L102 81.501V103.71L184.27 151.209L266.539 103.711V81.501Z",
    fill: "#10C237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.54 81.5005L184.271 128.999L102.001 81.5005L184.271 34.0024L266.54 81.5005Z",
    fill: "#00FF38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.499 118.154L137.839 82.2847L150.825 74.7872L213.09 96.4509L202.632 102.488L188.963 97.3585L177.071 104.225L185.956 112.117L175.499 118.154ZM170.578 98.5029L178.984 93.6492L164.563 88.0853C162.513 87.2698 160.462 86.4806 158.412 85.7177C156.361 84.9022 154.767 84.2708 153.627 83.8236C154.402 84.4813 155.473 85.3889 156.84 86.5464C158.252 87.6776 159.642 88.8482 161.009 90.0584L170.578 98.5029ZM215.455 95.0852L206.228 89.7581L216.138 84.0363L184.699 65.8846L174.788 71.6063L165.561 66.2792L195.634 48.9166L204.861 54.2438L194.951 59.9655L226.391 78.1173L236.301 72.3955L245.528 77.7227L215.455 95.0852Z",
    fill: "#132E19"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_2007_1191)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -98,
    cy: 59.0024,
    rx: 118,
    ry: 94,
    fill: "#10C237"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.50244,
    width: 237,
    height: 114,
    rx: 6.5,
    stroke: "#10C237",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2007_1191",
    x: 84.6077,
    y: 16.6107,
    width: 199.324,
    height: 151.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.69589
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 1 0 0 0 0 0.2525 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2007_1191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2007_1191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2007_1191",
    x: -287.1,
    y: -106.098,
    width: 378.2,
    height: 330.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.55,
    result: "effect1_foregroundBlur_2007_1191"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_1191"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00244141,
    width: 240,
    height: 117,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalbalance2);
export default __webpack_public_path__ + "static/media/Personal balance2.ef8fc58805e83ff6390c2dbe2af7fa16.svg";
export { ForwardRef as ReactComponent };